import { css } from 'aphrodite';
import * as React from 'react';
import { s } from './styles';

const Input = React.forwardRef<React.ElementRef<'input'>, AphroditeStyled<React.ComponentProps<'input'>>>(
	({ type, styles = [], ...props }, ref) => {
		return <input type={type} data-slot='input' ref={ref} className={css(s.input, ...styles)} {...props} />;
	}
);
Input.displayName = 'Input';

function InputGroup({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) {
	return <div data-slot='input-group' className={css(s.inputGroup, ...styles)} {...props} />;
}

function InputAddon({
	styles = [],
	mode = 'default',
	...props
}: AphroditeStyled<React.ComponentProps<'div'>> & { mode?: 'default' | 'icon' }) {
	return <div data-slot='input-addon' className={css(s.inputAddon, s[`inputAddon${mode}`], ...styles)} {...props} />;
}

const InputWrapper = React.forwardRef<React.ElementRef<'div'>, AphroditeStyled<React.ComponentProps<'div'>>>(
	({ styles = [], ...props }, ref) => {
		return <div data-slot='input-wrapper' ref={ref} className={css(s.input, s.inputWrapper, ...styles)} {...props} />;
	}
);
InputWrapper.displayName = 'InputWrapper';

export { Input, InputAddon, InputGroup, InputWrapper };
